import { Badge } from "@/components/ui-lab/badge"
import { Card, CardContent } from "@/components/ui-lab/card"

export const MyOverview = () => {
  const keySkills = [
    "JavaScript",
    "TypeScript",
    "React",
    "Next.js",
    "Node.js",
    "Express",
    "PostgreSQL",
    "AWS",
    "CI/CD",
    "Deployment",
  ]

  return (
    <Card className="border-0 shadow-lg bg-white dark:bg-gray-800 mb-8">
      <CardContent className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8">
        <div suppressHydrationWarning>
          <h3 className="text-2xl font-semibold mb-2 text-teal-700 dark:text-teal-400">About This Software Engineer</h3>
          <p className="text-base leading-relaxed mb-4">
            I am a senior full stack JavaScript software engineer with over 6+ years of professional experience building
            scalable web applications. My expertise spans Node.js backend development, React and Vue.js frontend
            frameworks, and modern deployment pipelines using CI/CD practices.
          </p>
          <p className="text-base leading-relaxed mb-4">
            I specialize in end-to-end software development using TypeScript, with a strong focus on performance
            optimization, clean code practices, and production-grade deployments on AWS infrastructure.
          </p>
        </div>

        <div suppressHydrationWarning>
          <h3 className="text-2xl font-semibold mb-2 text-teal-700 dark:text-teal-400">Core Technologies</h3>
          <div className="flex flex-wrap gap-2">
            {keySkills.map((skill) => (
              <Badge
                key={skill}
                variant="tech"
                className="px-3 py-1 text-sm font-medium rounded-full border-teal-500 bg-teal-50 dark:bg-teal-900/30 text-teal-700 dark:text-teal-300 cursor-default"
              >
                {skill}
              </Badge>
            ))}
          </div>

          <p className="text-base leading-relaxed mt-6 text-gray-600 dark:text-gray-400">
            Based in Nepal, I am passionate about solving complex technical challenges and mentoring teams. I excel at
            designing scalable systems, implementing deployment strategies, and delivering production-ready software
            solutions.
          </p>
        </div>
      </CardContent>
    </Card>
  )
}
